import { FC, ReactNode } from "react";
import { createPortal } from "react-dom";
import { usePinnedHeaderVisible } from "./useTopBarSearchVisible";

/**
 * 1NOW-11153: the top bar, pinned to the top of the screen once the page's own
 * header has scrolled away, so the search (the Search pill on phones) stays in
 * reach on every page that has it, as on the DFW site.
 *
 * The header's own `sticky` cannot do this: #root is `overflow: hidden`
 * (public/index.html; turning that off app-wide was tried and reverted, see
 * FollowScroll), and Design B's home, About and Contact draw the header inside
 * a one-screen banner. So, as on Design B's home before, a copy is fixed to the
 * top; usePinnedHeaderVisible says when. Each design's router renders it once,
 * with its own bar inside and its scope and z-index in `className`. Portalled
 * so no transformed ancestor can turn "fixed" into "fixed to that box".
 */
const PinnedHeader: FC<{ className?: string; children: ReactNode }> = ({
  className = "",
  children,
}) => {
  const show = usePinnedHeaderVisible();
  if (!show) return null;
  return createPortal(
    <div className={`nc-Header-pinned fixed inset-x-0 top-0 shadow-sm ${className}`}>
      {children}
    </div>,
    document.body,
  );
};

export default PinnedHeader;
